import { type ActivityEvent } from '../../api/activity.api.js';

type SortableEvent = Pick<ActivityEvent, 'capturedAt' | 'reviewPriority'>;

function priorityRank(event: SortableEvent): number {
  return event.reviewPriority === 'high' ? 0 : 1;
}

/** High priority first, newest first within each priority; the input is left untouched. */
export function sortPendingActivityEvents<T extends SortableEvent>(events: readonly T[]): T[] {
  return [...events].sort(
    (left, right) =>
      priorityRank(left) - priorityRank(right) || Date.parse(right.capturedAt) - Date.parse(left.capturedAt),
  );
}
